<template>
    <Layout>
        <Titlebar title="Checklists" :links="links" />
        <Table :table="table" :row_action="showChecklist" />
    </Layout>
</template>

<script>
    import { links } from '@/Mixins'
    import Table from '@/Components/Table'

    export default {
        mixins: [links],
        components: {
            Table
        },
        props: {
            table: {
                type: Object,
                default: {}
            }
        },
        methods: {
            showChecklist(id) {
                const link = route('checklists.show', id);
                this.$inertia.visit(link);
            }
        }
    }
</script>
